import type { DbExecutor } from "../executor";
import type { ProjectStatus } from "../../domain/status";

interface StatusRow {
  id: string;
  display_name: string;
  sort_order: number;
  is_system: number;
}

export class StatusRepository {
  constructor(private readonly db: DbExecutor) {}

  async listStatuses(): Promise<ProjectStatus[]> {
    const rows = await this.db.select<StatusRow>(
      "SELECT id, display_name, sort_order, is_system FROM project_statuses ORDER BY sort_order",
    );
    return rows.map((row) => ({
      id: row.id,
      displayName: row.display_name,
      sortOrder: Number(row.sort_order),
      isSystem: Number(row.is_system) === 1,
    }));
  }
}
